import React from 'react'

import Block from '../Block'
import Scheduling from '../Scheduling'

const ItemList = ({ item }) => {
  return !item.block ? (
    <Scheduling key={item.id} item={item} />
  ) : (
    <Block key={item.id} item={item} />
  )
}

export default ItemList
